import * as microsoftTeams from '@microsoft/teams-js';
microsoftTeams.initialize();
export default microsoftTeams;